import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  BidvBankTransferService,
  BidvBankTransferWhitelistEntity,
  UpdateBidvBankTransferWhitelistDto,
} from 'services/openapi';

import { BidvBankTransferServiceKeys } from '../queries/constants';

export type { UpdateBidvBankTransferWhitelistDto } from 'services/openapi';

export const useUpdateBidvBankTransferWhitelistMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      BidvBankTransferWhitelistEntity,
      Error,
      UpdateBidvBankTransferWhitelistDto
    >({
      mutationFn: (variables: UpdateBidvBankTransferWhitelistDto) => {
        return BidvBankTransferService.bidvBankTransferControllerUpdateBidvBankTransferWhitelist(
          variables,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [BidvBankTransferServiceKeys.GET_BANK_TRANSFER_WHITELIST],
        });
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
